import * as React from 'react';

const Location = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={24} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1339-1126H581v8701h-1920z" />
            <g
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.2}
                transform="translate(1)"
            >
                <circle cx={8} cy={8.25} r={3.75} />
                <path d="M8 .75a7.5 7.5 0 0 1 7.5 7.5c0 3.407-5.074 11.95-6.875 14.665a.75.75 0 0 1-1.25 0C5.574 20.2.5 11.657.5 8.25A7.5 7.5 0 0 1 8 .75" />
            </g>
        </g>
    </svg>
);
export default Location;
